/* eslint-disable no-unused-vars */
import React from 'react';
import { Tools } from '@/@corefabriccanvas';
import {
  CircleIcon,
  DashedLineIcon,
  LineIcon,
  RectangleIcon,
  TextIcon,
  TriangleIcon,
} from '@/icons';
import { ArrowIcon } from '@/icons/ArrowIcon';

interface ShapesSubToolProps {
  setTool: (tool: Tools) => void;
  subtoolPosition: string; // Expected position values (e.g., "left", "right")
}

const ShapesSubTool: React.FC<ShapesSubToolProps> = ({
  setTool,
  subtoolPosition,
}) => {
  return (
    <div
      className={`sub-tools shapes-sub-tool ${subtoolPosition}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="shape-buttons">
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.Line);
          }}
        >
          <LineIcon />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.DashedLine);
          }}
        >
          <DashedLineIcon />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.Arrow);
          }}
        >
          <ArrowIcon />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.Triangle);
          }}
        >
          <TriangleIcon />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.Rectangle);
          }}
        >
          <RectangleIcon />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.Circle);
          }}
        >
          <CircleIcon />
        </button>
        <button
          className="subtool-icon-button"
          onClick={() => {
            setTool(Tools.Text);
          }}
        >
          <TextIcon />
        </button>
      </div>
    </div>
  );
};

export default ShapesSubTool;
